import React from 'react'
import styled from 'styled-components'
import GGOOLLFF from '@/assets/images/logo.png'
import GNB from '@/components/common/gnb'
import HeaderAuth from '@/components/main/signin/header/headerAuth'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAppDispatch } from '@/redux/hooks'
import { setSearchParams } from '@/redux/slices/golfSearchSlice'

const HeaderContainer = styled.header`
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  width: 100%;
  height: 76px;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid #e0e0e0;
`

// const HeaderContent = styled.div`
//   max-width: 60%;
//   width: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   @media (max-width: 768px) {
//     max-width: 90%;
//   }
// `

const HeaderContent = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  /* 태블릿 */
  @media (max-width: 768px) {
    max-width: 90%;
    padding: 0 10px;
  }

  /* 모바일 */
  @media (max-width: 480px) {
    max-width: 95%;
    padding: 0 8px;
    flex-wrap: wrap;
    gap: 10px;
  }

  /* 매우 작은 모바일 */
  @media (max-width: 360px) {
    max-width: 100%;
    padding: 0 5px;
    gap: 8px;
  }

  /* 초소형 화면 (iPhone SE 등) */
  @media (max-width: 320px) {
    padding: 0 3px;
    gap: 5px;
  }
`
const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  img {
    height: 40px;
    width: auto;
  }
`

const GNBContainer = styled.nav`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  margin-left: 20px;

  @media (max-width: 768px) {
    overflow-x: auto;
    white-space: nowrap;
    margin-left: 8px;
  }
`

const HeaderAuthContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const Header: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const handleMainLogoClick = () => {
    dispatch(
      setSearchParams({
        bizNm: null,
        maxPrice: null,
        areaCd: null,
        dayType: 'weekday',
        months: null,
        membershipYn: 'A',
        holeType: '',
        confidenceLvlCd: '',
      }),
    )
    navigate('/main')
  }

  return (
    <HeaderContainer>
      <HeaderContent>
        <LogoContainer role="button" onClick={handleMainLogoClick}>
          <img src={GGOOLLFF} alt="꿀프 메인 로고" />
        </LogoContainer>

        <GNBContainer>
          <GNB />
        </GNBContainer>

        <HeaderAuthContainer>
          <HeaderAuth />
        </HeaderAuthContainer>
      </HeaderContent>
    </HeaderContainer>
  )
}

export default Header
